export default __webpack_public_path__ + "static/media/glrc.content.full_courses.35541f26.jpg";